import React from "react"
import styled from "styled-components"
import Image from "../Image"
import { Card } from "@mostlycode/ui"
import { getIconFromUrl } from "utils/iconResolver"
import StylishIcon from "components/StylishIcon"

const StyledMember = styled(Card)`
  background: ${(props) => props.theme.colors.white};
  padding: 0;
  box-shadow: none;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 10px 20px rgba(50, 50, 86, 0.2);
  // filter: drop-shadow(0 5px 10px rgba(50, 50, 86, 0.25));

  ${(props) => props.theme.media.tablet_landscape_up`
    & + & {
      margin-top: 0;
    }
  `}
`

const StyledInfo = styled.div`
  padding: 2rem;
  white-space: nowrap;
  position: relative;
  h6 {
    margin: 0;
  }

  p {
    margin: 0;
  }
`

const StyledImage = styled(Image)`
  border-radius: 0;
  border-radius: 5px 5px 0 0;
  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 95%);
`

const StyledIcon = styled(StylishIcon)`
  position: absolute;
  top: -4rem;
  right: 0;
  z-index: 50;
  margin-right: 0.5rem;

  svg:first-child {
    fill: ${(props) => props.theme.colors.poppy};
  }

  svg:last-child {
    fill: ${(props) => props.theme.colors.plush};
  }
`

function TeamMember({ content, fluid, ...props }) {
  return (
    <StyledMember>
      <StyledImage fluid={fluid} {...props} />
      <StyledInfo>
        <h6>{content.name}</h6>
        <StyledIcon
          size={6}
          bg="blob-two"
          icon={getIconFromUrl(content.icon.url)}
        />
        {content.team_role}
      </StyledInfo>
    </StyledMember>
  )
}

export default TeamMember
